const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Format a leaderboard score as a distance in meters (paper-fly).
 * Kept as `formatUsd` to avoid touching all call sites; semantically a
 * meter-distance formatter now.
 */
export function formatUsd(n) {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  return `${formatter.format(Math.round(n))}m`;
}
